
import LogoSvg from '@/assets/icons/full-logo.svg?inline'

export default {
  name: 'Logo',

  components: {
    LogoSvg,
  },
}
